<template>
  <div>
    <!-- Iconografia desktop -->
    <div class="mb-3 px-0 d-none d-lg-block pb-2">
      <b-row class="justify-content-center text-morado-claro">
        <b-col cols="auto" class="font-weight-bold pr-0">
          Iconografía:
        </b-col>
        <b-col cols="auto" class="px-2 bd-highlight"
          ><FontAwesomeIcon
            icon="dollar-sign"
            class="mr-2 text-morado-claro"
          />Copago</b-col
        >
        <b-col cols="auto" class="px-2 bd-highlight"
          ><FontAwesomeIcon icon="female" class="mr-2 text-morado-claro" />Solo
          mujeres</b-col
        >
        <b-col cols="auto" class="px-2 bd-highlight border-left"
          ><FontAwesomeIcon icon="male" class="mr-2 text-morado-claro" />Solo
          hombres</b-col
        >
        <b-col cols="auto" class="px-2 bd-highlight border-left"
          ><FontAwesomeIcon
            icon="restroom"
            class="mr-1 text-morado-claro"
          />Mixto</b-col
        >
        <b-col cols="auto" class="px-2 bd-highlight border-left"
          ><span class="mr-2 font-weight-bold text-morado-claro">SEP</span
          >Subvención Escolar Preferencial</b-col
        >
        <b-col cols="auto" class="px-2 bd-highlight border-left"
          ><span class="mr-2 font-weight-bold text-morado-claro">PIE</span
          >Programa de Integración Escolar</b-col
        >
      </b-row>
    </div>

    <div class="d-block d-lg-none mx-2">
      <b-button
        id="toggle-iconografia-movil"
        data-testid="toggle-iconografia-movil"
        variant="outline"
        class="text-morado-claro mt-3 text-center w-100 rounded-0 h6 bg-morado-claro"
        @click="iconografiaMovil = !iconografiaMovil"
      >
        <span class="h6 font-weight-bold mr-2 text-morado-claro"
          >Ver iconografía utilizada</span
        >
        <FontAwesomeIcon
          v-if="!iconografiaMovil"
          icon="plus"
          class="ml-2 py-0 mr-1"
        ></FontAwesomeIcon>
        <FontAwesomeIcon
          v-else
          icon="minus"
          class="ml-2 py-0 mr-1"
        ></FontAwesomeIcon>
      </b-button>

      <!--  ICONOGRAFIA MOVIL-->
      <b-collapse
        class="mb-3 bg-light py-3 px-3"
        id="ver-iconografia-movil"
        data-testid="ver-iconografia-movil"
        v-model="iconografiaMovil"
      >
        <b-row class="justify-content-center text-morado-claro mx-0">
          <b-col cols="6" class="row small px-0 m-0">
            <b-col cols="2" class="px-0 text-center"
              ><FontAwesomeIcon icon="dollar-sign" class="text-morado-claro h6"
            /></b-col>
            <span class="col-10 px-1">Copago</span>
          </b-col>
          <b-col cols="6" class="row small px-0 m-0">
            <b-col cols="2" class="px-0 text-center"
              ><FontAwesomeIcon icon="female" class="text-morado-claro h6"
            /></b-col>
            <span class="col-10 px-1">Solo mujeres</span>
          </b-col>
          <b-col cols="6" class="row small px-0 m-0">
            <b-col cols="2" class="px-0 text-center"
              ><FontAwesomeIcon icon="male" class="text-morado-claro h6"
            /></b-col>
            <span class="col-10 px-1">Solo hombres</span>
          </b-col>
          <b-col cols="6" class="row small px-0 m-0">
            <b-col cols="2" class="px-0 text-center"
              ><FontAwesomeIcon icon="restroom" class="text-morado-claro h6"
            /></b-col>
            <span class="col-10 px-1">Mixto</span>
          </b-col>
          <b-col cols="6" class="row small px-0 m-0">
            <b-col
              cols="2"
              class="font-weight-bold text-morado-claro px-0 text-center"
              >SEP</b-col
            >
            <span class="col-10 px-1">Subvención Escolar Preferencial</span>
          </b-col>
          <b-col cols="6" class="row small px-0 m-0">
            <b-col
              cols="2"
              class="font-weight-bold text-morado-claro px-0 text-center"
              >PIE</b-col
            >
            <span class="col-10 px-1">Programa de Integración Escolar</span>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faDollarSign,
  faFemale,
  faMale,
  faRestroom,
  faPlus,
  faMinus
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDollarSign, faFemale, faMale, faRestroom, faPlus, faMinus);
export default {
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      iconografiaMovil: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/Iconografia.vue